import { NgModule } from '@angular/core';
import { LucideAngularModule, icons } from 'lucide-angular';

import { Menu, BookOpen, TrendingUp, Building2, Calendar, Users, Search, Funnel, DollarSign, CreditCard, CircleCheckBig,
  Landmark, FileSearchCorner, ChevronLeft, ChevronsLeft, ChevronsRight, ChevronRight, FileText, Download } from 'lucide-angular';

const icones = {
  Menu, BookOpen, TrendingUp, Building2, Calendar, Users, Search, Funnel, DollarSign, CreditCard, CircleCheckBig,
  Landmark, FileSearchCorner, ChevronLeft, ChevronsLeft, ChevronsRight, ChevronRight, FileText, Download
};

@NgModule({
  imports: [
    LucideAngularModule.pick(icons)
  ],
  exports: [
    LucideAngularModule
  ]
})
export class LucideModule {}
